import { captureEvent } from '../metrics/captureEvent'
import { stripUrlQuery } from '../default/stripUrlQuery'

const isDownsellUrl = (/** @type {string} */ url) =>
  /offerwall|thanks/i.test(url)

/**
 * Captures submit redirected to chat or downsell.
 *
 * @param {string} url - destination URL
 * @param {string} [prefix] - event name prefix, for pages that report under
 * their own (e.g. 'my-results' gives my-results-sent-to-chat)
 */
export function captureSubmitSentTo(url, prefix = 'form') {
  const target = isDownsellUrl(url || '') ? 'downsell' : 'chat'

  /*
   * The target is derived from the URL, and the query string is stripped off so
   * destinations aggregate by page. Query params are deliberately not recorded:
   * the thanks URL carries a base64 blob of lead PII, and per-lead values would
   * blow up metric cardinality.
   */
  captureEvent(`${prefix}-sent-to-${target}`, {
    destination: stripUrlQuery(url),
  })
}
